module.exports = __webpack_public_path__ + "static/media/plantilla_encabezado_reportes_laridae.a5e96b73.png";